<template>
    <van-popup v-model="show" position="bottom" @open="handleOpen" :overlay="true" style="width:100%;height:425px">
        <div class="date-picker-title">
            <template v-if="titleError == ''">{{title == 'start' ? '选择开始时间' : '选择结束时间'}}</template>
            <template v-if="titleError"><span style="color:#FC464A">{{titleError ? titleError : ''}}</span></template>
        </div>
        <van-datetime-picker
                v-show="title=='start'"
                v-model="currentStart"
                type="date"
                :show-toolbar="false"
                :item-height="40"
                style="margin-top: 20px;"
                @change="changeDate('start',$event)"
        />
        <van-datetime-picker
                v-show="title=='end'"
                v-model="currentEnd"
                type="date"
                :show-toolbar="false"
                :item-height="40"
                style="margin-top: 20px;"
                @change="changeDate('end',$event)"
        />
        <van-row style="margin-top:20px;height:40px;line-height:40px;font-size:14px;color:#7d7e80">
            <van-col span="10" align="center" style="border-bottom:1px solid #26a2ff;" :style="{color:title=='start' ? '#26a2ff' : ''}">
                <span @click="title='start'">{{start}}</span>
            </van-col>
            <van-col span="4" align="center"> 至 </van-col>
            <van-col span="10" align="center" style="border-bottom:1px solid #26a2ff;" :style="{color:title=='end' ? '#26a2ff' : ''}">
                <span @click="title='end'">{{end}}</span>
            </van-col>
        </van-row>

        <van-row style="margin-top:20px;">
            <van-col span="12" align="center">
                <van-button type="default" style="width:100%" @click="show=false">取消</van-button>
            </van-col>
            <van-col span="12" align="center">
                <van-button type="info" style="width:100%" @click="submit()">确认</van-button>
            </van-col>
        </van-row>

    </van-popup>
</template>
<script type="text/ecmascript-6">

    export default{
        data(){
            return {
                value:'',
                show:false,
                title:'',
                titleError:'',
                start:'',
                end:'',
                currentStart:'',
                currentEnd:'',
            }
        },
        props:['startProp','endProp'],
        mounted(){

        },
        methods:{
            handleOpen(){
                this.title = 'start'
                setTimeout(() => {
                    this.start = this.startProp
                    this.end   = this.endProp
                    //设置月份时，会加1，这里手动-1
                    this.currentStart = new Date(this.start.split('-')[0],this.start.split('-')[1]-1,this.start.split('-')[2])
                    this.currentEnd = new Date(this.end.split('-')[0],this.end.split('-')[1]-1,this.end.split('-')[2])
                })
            },
            changeDate(type,event){
                this.titleError = ''
                let date_arr = event.getValues()
                if(type == 'start')
                    this.start = date_arr[0]+'-'+date_arr[1]+'-'+date_arr[2]
                if(type == 'end')
                    this.end = date_arr[0]+'-'+date_arr[1]+'-'+date_arr[2]
            },
            submit(){
                this.titleError = ''
                if(this.start > this.end){
                    this.titleError = '时间选择错误'
                }else{
                    this.$emit('listenDatePickerEvent',this.start,this.end)
                    this.show = false
                }
            }
        }
    }
</script>
<style scoped>
    .c-row{
        margin-top:10px;
    }
    .date-picker-title{
        margin-top: 10px;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile/components/DatePicker.vue